// The blog: every published post, newest first, read from the site's database.
import { usePosts } from "../api/hooks";
import { useTitle } from "../ui/hooks";
import { Failed, Loading, PageHero } from "../ui/Section";
import { PostCard } from "./blog/PostCard";

export function Blog() {
  useTitle("Blog");
  const posts = usePosts();
  return (
    <>
      <PageHero kicker="§ Blog" title={<>Field notes on keeping AI accountable.</>}>
        Essays on what AI changes, what it costs, who holds the keys, and the parts that are still ours to decide. Subscribe with{" "}
        <a href="/rss.xml" className="link">
          RSS
        </a>
        .
      </PageHero>
      <section className="wrap py-14">
        {posts.isPending ? <Loading label="Loading articles" /> : null}
        {posts.isError ? <Failed what="the articles" retry={() => void posts.refetch()} /> : null}
        {posts.data ? (
          posts.data.length === 0 ? (
            <p className="lede py-10">The first articles are on their way.</p>
          ) : (
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {[...posts.data]
                .sort((a, b) => (a.series && a.series === b.series && a.part && b.part ? a.part - b.part : b.published_at.localeCompare(a.published_at)))
                .map((p, i) => (
                  <PostCard key={p.slug} post={p} large={i === 0} />
                ))}
            </div>
          )
        ) : null}
      </section>
    </>
  );
}
